(function () {
  var elementName = 'nyc-dynamic-product-description';

  if (!window.customElements || customElements.get(elementName)) return;

  var detailHeadings = [
    'jacket details',
    'leather jacket features',
    'product details',
    'jacket specifications',
    'product specifications',
    'specifications',
    'features'
  ];

  var descriptionHeadings = [
    'jacket description',
    'product description',
    'description',
    'jacket story',
    'product story',
    'the story',
    'story'
  ];

  var labelAliases = {
    'outer shell': 'Leather',
    'shell': 'Leather',
    'leather': 'Leather',
    'leather type': 'Leather',
    'material': 'Material',
    'inner shell': 'Inner shell',
    'lining': 'Lining',
    'colour': 'Color',
    'color': 'Color',
    'closure': 'Closure',
    'closure style': 'Closure',
    'collar': 'Collar',
    'collar style': 'Collar',
    'cuff': 'Cuffs',
    'cuffs': 'Cuffs',
    'cuff style': 'Cuffs',
    'cuffs style': 'Cuffs',
    'pocket': 'Pockets',
    'pockets': 'Pockets',
    'outside pocket': 'Outside pockets',
    'outside pockets': 'Outside pockets',
    'exterior pocket': 'Outside pockets',
    'exterior pockets': 'Outside pockets',
    'inside pocket': 'Inside pockets',
    'inside pockets': 'Inside pockets',
    'interior pocket': 'Inside pockets',
    'interior pockets': 'Inside pockets',
    'pattern': 'Pattern',
    'sleeve': 'Sleeves',
    'sleeves': 'Sleeves',
    'sleeve length': 'Sleeves',
    'care': 'Care',
    'care instructions': 'Care',
    'fit': 'Fit',
    'length': 'Length',
    'hardware': 'Hardware',
    'hood': 'Hood'
  };

  var preferredOrder = {
    Leather: 1,
    Material: 1,
    'Inner shell': 2,
    Lining: 3,
    'Lining composition': 3,
    Closure: 4,
    Color: 5,
    Collar: 6,
    Cuffs: 7,
    Pockets: 8,
    Sleeves: 9,
    Pattern: 10,
    Fit: 11,
    Length: 12,
    Hardware: 13,
    Hood: 14,
    Care: 15
  };

  function normalize(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function cleanLine(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/^\s*[○●•◦▪▫◆◇·*–—-]+\s*/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function titleCase(value) {
    return String(value || '')
      .trim()
      .replace(/\b\w/g, function (character) {
        return character.toUpperCase();
      });
  }

  function extractLines(source) {
    var clone = source.cloneNode(true);

    clone.querySelectorAll('script, style, meta').forEach(function (element) {
      element.remove();
    });

    clone.querySelectorAll('br').forEach(function (element) {
      element.replaceWith(document.createTextNode('\n'));
    });

    clone.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6, blockquote').forEach(function (element) {
      element.append(document.createTextNode('\n'));
    });

    return clone.textContent
      .split(/\n+/)
      .map(cleanLine)
      .filter(Boolean);
  }

  function parseSpecification(line, acceptUnknown) {
    var careLine = normalize(line);

    if (careLine.indexOf('wash & clean') === 0 || careLine.indexOf('wash and clean') === 0) {
      return { label: 'Care', value: line };
    }

    var separatorIndex = line.indexOf(':');
    if (separatorIndex < 1) return null;

    var originalLabel = cleanLine(line.slice(0, separatorIndex));
    var value = cleanLine(line.slice(separatorIndex + 1));
    if (!value) return null;

    var normalizedLabel = normalize(originalLabel);
    var label = labelAliases[normalizedLabel];

    if (label === 'Lining' && /\d+(?:\.\d+)?\s*%/.test(value)) {
      label = 'Lining composition';
    }

    if (!label && !acceptUnknown) return null;
    if (!label) label = titleCase(originalLabel.replace(/\s+(style|type)$/i, ''));

    return { label: label, value: value };
  }

  function pocketCount(value, type) {
    var normalizedValue = normalize(value);
    var match = normalizedValue.match(/\b(\d+|one|two|three|four|five|six)\b/);
    var numberWords = { one: '1', two: '2', three: '3', four: '4', five: '5', six: '6' };

    if (match) return (numberWords[match[1]] || match[1]) + ' ' + type;
    if (normalizedValue.indexOf(type) !== -1) return value;
    return value + ' ' + type;
  }

  function consolidateSpecifications(specifications) {
    var seen = {};
    var output = [];
    var outsidePockets = null;
    var insidePockets = null;
    var pocketOrder = Number.MAX_SAFE_INTEGER;

    specifications.forEach(function (specification, index) {
      if (specification.label === 'Outside pockets') {
        outsidePockets = specification.value;
        pocketOrder = Math.min(pocketOrder, index);
        return;
      }

      if (specification.label === 'Inside pockets') {
        insidePockets = specification.value;
        pocketOrder = Math.min(pocketOrder, index);
        return;
      }

      if (seen[specification.label]) return;
      seen[specification.label] = true;
      output.push({ label: specification.label, value: specification.value, order: index });
    });

    if (!seen.Pockets && (outsidePockets || insidePockets)) {
      var values = [];
      if (outsidePockets) values.push(pocketCount(outsidePockets, 'exterior'));
      if (insidePockets) values.push(pocketCount(insidePockets, 'interior'));
      output.push({ label: 'Pockets', value: values.join(' · '), order: pocketOrder });
    }

    return output
      .sort(function (first, second) {
        var firstPreferred = preferredOrder[first.label] || 100;
        var secondPreferred = preferredOrder[second.label] || 100;

        if (firstPreferred !== secondPreferred) return firstPreferred - secondPreferred;
        return first.order - second.order;
      })
      .slice(0, 12);
  }

  function findMarker(source, headings) {
    var candidates = Array.prototype.slice.call(source.querySelectorAll('h1, h2, h3, h4, h5, h6, p, strong, b'));
    var marker = candidates.find(function (element) {
      return headings.indexOf(normalize(element.textContent)) !== -1 && !['STRONG', 'B'].includes(element.tagName);
    });

    if (marker) return marker;

    marker = candidates.find(function (element) {
      return headings.indexOf(normalize(element.textContent)) !== -1;
    });

    if (!marker) return null;
    return marker.closest('p, h1, h2, h3, h4, h5, h6') || marker;
  }

  function storyAfterMarker(marker) {
    if (!marker || !marker.parentNode) return '';

    var holder = document.createElement('div');
    var sibling = marker.nextSibling;

    while (sibling) {
      holder.appendChild(sibling.cloneNode(true));
      sibling = sibling.nextSibling;
    }

    holder.querySelectorAll('script, style, meta').forEach(function (element) {
      element.remove();
    });

    return holder.innerHTML.trim();
  }

  function parseDescription(source) {
    var lines = extractLines(source);
    var hasDetailHeading = lines.some(function (line) {
      return detailHeadings.indexOf(normalize(line)) !== -1;
    });
    var specifications = [];
    var storyLines = [];
    var inDescription = false;
    var detailsStarted = !hasDetailHeading;

    lines.forEach(function (line) {
      var normalizedLine = normalize(line);

      if (detailHeadings.indexOf(normalizedLine) !== -1) {
        detailsStarted = true;
        return;
      }

      if (descriptionHeadings.indexOf(normalizedLine) !== -1) {
        inDescription = true;
        return;
      }

      if (inDescription) {
        storyLines.push(line);
        return;
      }

      var specification = parseSpecification(line, hasDetailHeading && detailsStarted);

      if (specification && detailsStarted) {
        specifications.push(specification);
        return;
      }

      if (specifications.length >= 3) storyLines.push(line);
    });

    return { specifications: consolidateSpecifications(specifications), storyLines: storyLines };
  }

  class DynamicProductDescription extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-dynamic-description-initialized')) return;
      this.setAttribute('data-dynamic-description-initialized', '');
      this.renderDescription();
    }

    renderDescription() {
      var source = this.querySelector('[data-dynamic-description-source]');
      var compact = this.querySelector('[data-dynamic-description-compact]');
      var grid = this.querySelector('[data-dynamic-description-grid]');
      var story = this.querySelector('[data-dynamic-description-story]');

      if (!source || !compact || !grid || !story) return;

      var parsed = parseDescription(source);
      if (parsed.specifications.length < 3) return;

      parsed.specifications.forEach(function (specification) {
        var item = document.createElement('div');
        var term = document.createElement('dt');
        var definition = document.createElement('dd');

        item.className = 'nyc-dynamic-description__item';
        term.textContent = specification.label;
        definition.textContent = specification.value;
        item.appendChild(term);
        item.appendChild(definition);
        grid.appendChild(item);
      });

      var descriptionMarker = findMarker(source, descriptionHeadings);
      var storyHtml = storyAfterMarker(descriptionMarker);

      if (storyHtml) {
        story.innerHTML = storyHtml;
        story.hidden = false;
      } else if (parsed.storyLines.length) {
        parsed.storyLines.forEach(function (line) {
          var paragraph = document.createElement('p');
          paragraph.textContent = line;
          story.appendChild(paragraph);
        });
        story.hidden = false;
      }

      compact.hidden = false;
      source.hidden = true;
      this.setAttribute('data-dynamic-description-ready', '');
    }
  }

  customElements.define(elementName, DynamicProductDescription);
})();
